import { getApi } from 'common/api-common'
import { blobbyStrings } from './strings'

const defaultStrings = {
  betterTogether: 'Better together',
  community: 'Community',
  communityEngagement:
    'Community Engagement creates positive impact <br class="d-sm-none" /> on regeneration and <br class="d-sm-none" /> social conditions.',
  communityEngagementContent: `<p class="mb-lg-8 mb-4">
At the Hoxton Mix, our mission is to make starting a business accessible for everyone and to provide a workspace which has a positive impact on regeneration by responding to local economic and social conditions. 
</p><p class="text-bold mb-0">
We believe small and medium enterprises (SMEs), can assist economic development, community engagement and local <br class="d-sm-none" /> physical regeneration.
</p>`,
  email: 'community@hoxtonmix.com',
  localEconomy: 'Local economy',
  ourCommunityMission: 'Our community mission',
  seoDescription:
    'We consider a way to improve failure rates is by combining young people, entrepreneurs and established companies and targeting sustainable growth across a more significant number of businesses.',
  seoTitle: 'Social Impact | Hoxton Mix',
  smeDescription: `<p class="text-semibold mb-lg-8 mb-4">
<strong>SMEs make up 99% of all London businesses</strong> and account for over <strong class="d-lg-inline d-none">40% of its employment</strong> <span class="d-lg-none">40% of its employment</span>. When performed correctly, SMEs provide sustainable employment, allow community ties and can energise neighbourhoods. 
</p><p class="text-semibold">
Sadly, SME failure rates are high (60% of London startups don’t last five years), and high-growth SMEs are often more likely to create value for investors than have a positive impact on the local economy.
</p>`,
  smeStat: '99% of all London businesses are SMEs',
  strengthIsOurDiversity: 'Strength is our diversity',
  strengthIsOurDiversityDescription:
    'A workspace that responds to an area’s needs',
  talkToUs:
    'Talk to us if you’d like <br /> to get involved and help grow our community',
  theVision: 'The Vision',
  theVisionDescription:
    '<span class="color-blue">OUR COMMUNITY GOALS:</span> WORKSPACE, <span class="color-yellow">KNOWLEDGE</span>, SUPPORT, <span class="color-purple3">OUTREACH</span>, <span class="color-purple2">COMMUNITY ENGAGEMENT</span>, REGENERATION, <span class="color-teal">SUSTAINABLE EMPLOYMENT</span>, <span class="color-pink" >INVESTMENT</span>',
  weAimToBringTogether:
    'We aim to bring together young people, entrepreneurs and established companies',
  weAimToBringTogetherDescription: `<p class="mb-lg-8 mb-4">We consider a way to improve failure rates is by combining young people, entrepreneurs and established companies and targeting sustainable growth across a more significant number of businesses.</p>
 <p class="mb-lg-8 mb-4">Although much of the press coverage around startups are often tech-oriented, from our decade of experience and helping over 15 thousand businesses, technology represents only a portion of London’s startup scene.</p> 
 <p>Strength is our diversity, and for Islington London Borough Council, it gives the possibility of working with a community workspace that is responsive to an area’s economic and social needs.</p>`,
  weArePassionateAboutEntrepreneurshipAndHelpingBusinessesThrive:
    'We’re passionate about entrepreneurship and helping businesses thrive.',
}
export const socialImpactStrings = getApi().makeStrings({
  en: defaultStrings,
  es: blobbyStrings(defaultStrings),
})
